import { cn } from '@/lib/utils'

export default function fadeIn(isVisible: boolean = true, className?: string) {
  return cn(
    'transition-opacity duration-300 ease-in-out',
    isVisible ? 'animate-fadeInDisplay' : 'animate-fadeOutDisplay opacity-0 h-0 overflow-hidden',
    className
  )
}
